import { render } from "./CreatePayment2.vue?vue&type=template&id=55b01f41"
import script from "./CreatePayment2.vue?vue&type=script&lang=js"
export * from "./CreatePayment2.vue?vue&type=script&lang=js"

import "./CreatePayment2.vue?vue&type=style&index=0&id=55b01f41&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__